import React from 'react'
import { LockOutlined, WarningOutlined } from '@ant-design/icons'
import { Card, Col, Flex, Row, Statistic, Typography, theme } from 'antd'
import { Link } from 'react-router-dom'
import { path } from '../../../libs/path'
import { WalletGuardStats } from './types'

type Props = {
  stats: WalletGuardStats | null
  loading: boolean
}

export const WGDashboardStatistics = ({ stats, loading }: Props) => {
  const { token } = theme.useToken()
  const metrics = [
    {
      key: 'total',
      label: 'Кошельков всего',
      color: token.colorText,
      status: null,
    },
    {
      key: 'clean',
      label: 'Успешно проверены',
      color: token.colorSuccess,
      status: null,
    },
    {
      key: 'suspicious',
      label: 'Подозрительные',
      color: token.colorWarning,
      status: 'SUSPICIOUS',
    },
    {
      key: 'dangerous',
      label: 'Высокий AML-риск',
      color: token.colorError,
      status: 'DANGEROUS',
    },
    {
      key: 'blocked',
      label: 'Заблокированные',
      color: token.colorTextSecondary,
      status: null,
    },
  ] as const

  return (
    <Row
      gutter={[20, 20]}
      aria-label="Общая статистика кошельков"
      aria-busy={loading}
    >
      {metrics.map(({ key, label, color, status }) => {
        const card = (
          <Card
            loading={loading}
            hoverable={Boolean(status)}
            style={{ height: '100%', boxShadow: token.boxShadowTertiary }}
          >
            <Flex vertical gap={4}>
              <Statistic
                value={stats?.[key] ?? '—'}
                groupSeparator=" "
                valueStyle={{ color, fontSize: 36, fontWeight: 700 }}
              />
              <Typography.Text type="secondary" style={{ fontWeight: 500 }}>
                {(key === 'suspicious' || key === 'dangerous') && (
                  <WarningOutlined style={{ color, marginRight: 8 }} />
                )}
                {key === 'blocked' && (
                  <LockOutlined style={{ color, marginRight: 8 }} />
                )}
                {label}
              </Typography.Text>
            </Flex>
          </Card>
        )

        return (
          <Col key={key} flex="1 1 200px" style={{ maxWidth: '100%' }}>
            {status ? (
              <Link
                to={`${path.walletGuard.wallets()}?status=${status}`}
                style={{ display: 'block', height: '100%' }}
              >
                {card}
              </Link>
            ) : (
              card
            )}
          </Col>
        )
      })}
    </Row>
  )
}
